import { render, staticRenderFns } from "./DictionaryRender.vue?vue&type=template&id=f3659f14&"
import script from "./DictionaryRender.vue?vue&type=script&lang=js&"
export * from "./DictionaryRender.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryRender.vue?vue&type=style&index=0&id=f3659f14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports